var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31264 4.94576C2.31264 2.35749 4.41085 0.259277 6.99912 0.259277C9.5874 0.259277 11.6856 2.35749 11.6856 4.94576V7.45771C13.0524 8.09373 14 9.47934 14 11.0863V13.2682C14 15.4773 12.2091 17.2682 10 17.2682H4C1.79086 17.2682 0 15.4773 0 13.2682V11.0863C0 9.48002 0.946743 8.09492 2.31264 7.45852V4.94576ZM10.1856 4.94576V7.09049C10.1241 7.08768 10.0622 7.08626 10 7.08626H4C3.9372 7.08626 3.87474 7.08771 3.81264 7.09057V4.94576C3.81264 3.18592 5.23928 1.75928 6.99912 1.75928C8.75897 1.75928 10.1856 3.18591 10.1856 4.94576ZM10 8.58626H4C2.61929 8.58626 1.5 9.70555 1.5 11.0863V13.2682C1.5 14.6489 2.61929 15.7682 4 15.7682H10C11.3807 15.7682 12.5 14.6489 12.5 13.2682V11.0863C12.5 9.70555 11.3807 8.58626 10 8.58626ZM8.20679 11.0358C8.20679 10.4835 7.75907 10.0358 7.20679 10.0358C6.6545 10.0358 6.20679 10.4835 6.20679 11.0358V12.3956C6.20679 12.9479 6.6545 13.3956 7.20679 13.3956C7.75907 13.3956 8.20679 12.9479 8.20679 12.3956V11.0358Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0f3def46.svg";
export { ForwardRef as ReactComponent };